import { Button, Dialog, DialogBody, DialogHeader, Textarea } from '@material-tailwind/react';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { renderLocation } from '../../lib/formatters';
import { SocketRPC, socketEmit } from '../../lib/socket';

const ChangeAddressModal = ({
	producerLocation,
	changeAddressModalOpen,
	toggleOpen,
	onSubmitSuccess = (newLocation: Object) => {},
}) => {
	const [loading, setLoading] = useState(false);
	const [streetAddress, setStreetAddress] = useState<string>();
	const [pickupInstructions, setPickupInstructions] = useState<string | undefined>();
	const [crossStreets, setCrossStreets] = useState<string | undefined>();

	useEffect(() => {
		if (!producerLocation) {
			return;
		}
		setStreetAddress(renderLocation(producerLocation));
		setPickupInstructions(producerLocation?.location?.instructions?.english);
		setCrossStreets(producerLocation?.location?.crossStreets);
	}, [producerLocation]);

	const onSubmitChangeAddress = async () => {
		if (!streetAddress) {
			toast.error('Please ensure all fields are filled out.');
			return;
		}

		const { producerLocationKey } = producerLocation;

		const body = { address: streetAddress, pickupInstructions, crossStreets, producerLocationKey };
		console.log('body', body);

		setLoading(true);
		socketEmit(SocketRPC.TryUpdateFoodTruckAddress, body)
			.then((res) => {
				if (!res.success) {
					throw new Error(res.message);
				}
				const { location } = res;
				toast.success('Address changed successfully!');
				onSubmitSuccess(location);
				toggleOpen();
			})
			.catch((err) => {
				toggleOpen();
				toast.error(`Failed to change address ${err}`);
			})
			.finally(() => {
				setLoading(false);
			});
	};

	return (
		<Dialog open={changeAddressModalOpen} handler={toggleOpen}>
			<DialogHeader>{`Update Truck Address`}</DialogHeader>
			<DialogBody divider>
				<div className="flex flex-col">
					<div className="py-2 flex gap-x-6 px-2 justify-center items-center">
						<Textarea
							size="md"
							label="Address"
							value={streetAddress}
							onChange={(e) => setStreetAddress(e.target.value)}
							maxLength={250}
						></Textarea>
					</div>
					<div className="py-2 flex gap-x-6 px-2 justify-center items-center">
						<Textarea
							size="md"
							label="Cross Streets"
							value={crossStreets}
							onChange={(e) => setCrossStreets(e.target.value)}
							maxLength={250}
						></Textarea>
					</div>
					<div className="py-2 flex gap-x-6 px-2 justify-center items-center">
						<Textarea
							size="md"
							label="Pickup Instructions"
							value={pickupInstructions}
							onChange={(e) => setPickupInstructions(e.target.value)}
							maxLength={250}
						></Textarea>
					</div>
					<Button className="w-full bg-blue-600 hover:bg-blue-400 text-white" onClick={onSubmitChangeAddress}>
						{loading ? 'Loading' : `Update Address!`}
					</Button>
				</div>
			</DialogBody>
		</Dialog>
	);
};

export default ChangeAddressModal;
